<template>
    <div>
        <div class="back">
            <a href="/function"><img src="/static/tutorial/back.png" alt=""></a>
        </div>
        <div class="introduction">

            <h1>{{this.EventBus.getText("operation_title")}}</h1>
            <p>{{this.EventBus.getText("operation_text")}}</p>
            <img :src=operation_img alt="">
        </div>

        <js/>
        <Footer/>
    </div>
</template>

<script>
import Operation from '../../assets/language/operation.json'
export default {
    beforeCreate() {
        this.EventBus.loadLanguage(Operation);
    },
    data(){
        return{
            operation_img: this.EventBus.getText("operation_img"),
        }
    }
}
</script>
<style scoped>
    .introduction{
        margin: 7vw auto;
        margin-bottom: 0;
        /* height: 1080px; */
        /* background-color: blue; */
        text-align: center;
    }

    h1{
        font-weight: 700;
        color: #141414;
        font-size: 30px;
    }

    


    .introduction img{
        width: 1000px;
        margin: 1vw;
        box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
    }

    .back img{
        margin-left: 100px;
        width: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
</style>


// WEBPACK FOOTER //
// src/pages/tutorial_functions/function_screen_control.vue